import React, { PureComponent } from 'react';
import Grid from "@mui/material/Grid";
import Switch from "../../../../components/Switch";
import BubbleSelectBlock from "../../../../components/BubbleSelectBlock";
import NumberInput from "../../../../components/TextFields/NumberInput";
import Text from "../../../../components/Text";
import TextInput from "../../../../components/TextFields/TextInput";
import BlockContent from '../../../../components/BlockContent';
import HeaderDiv from '../../../../components/HeaderDiv';
import { colors } from "../../../../theme";
import Bubble from "../../../../components/Bubble";
class ProductBlock extends PureComponent {
  state = {
    data: {
      ...this.props.data
    }
  };
  async componentDidUpdate(prevProps) {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (this.props.type === "modular") {
      return;
    }
    // if the user has selected a new plan design then save the init data in global state so it's there for the save
    if (this.props.selectedDesignID !== prevProps.selectedDesignID) {
      this.props.savePlanDesignBenefitInitData(this.props.selectedClassID, this.props.selectedDesignID, 'specialityProducts', {
        ...this.props.specialityProducts,
        [this.props.specialityProductID]: {
          ...this.props.productMeta.defaults,
          // set the product defaults first
          ...this.props.data // overwrite the defaults with any plan design data that we have saved for this product
        }
      });
    } else if (this.props.data !== prevProps.data) {
      // only update the state if the data has actually changed
      this.setState({
        data: {
          ...this.props.data
        }
      });
    }
  }
  _handleChange = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    this.setState({
      data: {
        ...this.state.data,
        [field]: value
      }
    });
  };
  _saveInGlobalState = (field, value) => {
    // we are viewing a revision so we don't need to set data in state
    if (this.props.revision) {
      return;
    }
    if (field === 'notes' && value.toString().length === 0) {
      value = null;
    }
    const specialityProductData = {
      ...this.props.specialityProducts[this.props.specialityProductID],
      [field]: value
    };
    if (this.props.type === "modular") {
      this.props.saveModularField(this.props.classID, null, null, 'specialityProducts', this.props.specialityProductID, specialityProductData);
    } else {
      this.props.savePlanDesignField(this.props.selectedClassID, this.props.selectedDesignID, 'specialityProducts', this.props.specialityProductID, specialityProductData);
    }
    this.props.setChangesMadeFlag();
  };
  render() {
    if (!this.state.data) {
      return null;
    }
    const {
      errors,
      whitelabel,
      revision,
      isRevisionBlock,
      name,
      language
    } = this.props;
    const data = this.state.data;
    const isSelected = Boolean(data.isSelected);
    return /*#__PURE__*/React.createElement(BlockContent, {
      style: isRevisionBlock ? {
        backgroundColor: '#F7F9FA'
      } : null
    }, /*#__PURE__*/React.createElement(HeaderDiv, {
      style: {
        borderBottom: isSelected ? "1.5px solid #F1F1F1" : null
      }
    }, /*#__PURE__*/React.createElement(Text, {
      large: true,
      bold: true,
      display: "block",
      margin: "20px 0",
      color: whitelabel.primaryColor || colors.skyBlue
    }, revision ? isRevisionBlock ? `${name} (${this.props.carrier}) - ${revision.revisionID}` : `${name} (${this.props.carrier}) - Current` : `${name} (${this.props.carrier})`), /*#__PURE__*/React.createElement(Switch, {
      checked: data.isSelected,
      onChange: () => this._saveInGlobalState("isSelected", !isSelected)
    })), isSelected && /*#__PURE__*/React.createElement("div", {
      style: {
        paddingTop: 20,
        paddingBottom: 50
      }
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      direction: "row",
      alignItems: "center",
      spacing: 2
    }, this.props.fields.map(field => {
      let element = null;
      // if the field has a display clause, only show the element if the value is correct
      if (field.displayClause) {
        if (data[field.displayClause.dataFieldLabel] !== field.displayClause.value) {
          return null;
        }
      }
      switch (field.type) {
        case 'bubble':
          element = /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: field.xs || 12,
            sm: field.sm || 12
          }, /*#__PURE__*/React.createElement(Bubble, {
            label: field.label[language],
            isSelected: data[field.dataFieldLabel],
            onClick: () => this._saveInGlobalState(field.dataFieldLabel, !data[field.dataFieldLabel]),
            disabled: field.disabled
          }));
          break;
        case 'bubbleSelectBlock':
          const options = field.options[language];
          element = /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: field.xs || 12,
            sm: field.sm || 12
          }, /*#__PURE__*/React.createElement(BubbleSelectBlock, {
            label: field.label[language],
            first: {
              title: options[0].label,
              selected: data[options[0].dataFieldLabel],
              field: options[0].dataFieldLabel
            },
            second: {
              title: options[1].label,
              selected: data[options[1].dataFieldLabel],
              field: options[1].dataFieldLabel
            },
            third: !options[2] ? {} : {
              title: options[2].label,
              selected: data[options[2].dataFieldLabel],
              field: options[2].dataFieldLabel
            },
            handleChange: this._saveInGlobalState,
            disabled: field.disabled
          }));
          break;
        case 'number':
          element = /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: field.xs || 6,
            sm: field.sm || 4
          }, /*#__PURE__*/React.createElement(NumberInput, {
            label: field.label[language],
            fullWidth: true,
            value: data[field.dataFieldLabel],
            onChange: e => this._handleChange(field.dataFieldLabel, e.target.value),
            onBlur: e => this._saveInGlobalState(field.dataFieldLabel, e.target.value),
            variant: "outlined",
            disabled: field.disabled
          }));
          break;
        case 'dollar':
          element = /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: field.xs || 6,
            sm: field.sm || 4
          }, /*#__PURE__*/React.createElement(NumberInput, {
            label: field.label[language],
            fullWidth: true,
            prefix: "$ ",
            value: data[field.dataFieldLabel],
            onChange: e => this._handleChange(field.dataFieldLabel, e.target.value),
            onBlur: e => this._saveInGlobalState(field.dataFieldLabel, e.target.value),
            variant: "outlined",
            disabled: field.disabled
          }));
          break;
        case 'dropdown':
          element = /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: field.xs || 6,
            sm: field.sm || 4
          }, /*#__PURE__*/React.createElement(TextInput, {
            label: field.label[language],
            fullWidth: true,
            value: data[field.dataFieldLabel],
            variant: "outlined",
            select: true,
            selectOptions: field.options[language],
            onChange: e => this._handleChange(field.dataFieldLabel, e.target.value),
            onBlur: e => this._saveInGlobalState(field.dataFieldLabel, e.target.value),
            disabled: field.disabled
          }));
          break;
        case 'percentage':
          element = /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: field.xs || 6,
            sm: field.sm || 4
          }, /*#__PURE__*/React.createElement(NumberInput, {
            label: field.label[language],
            fullWidth: true,
            suffix: "%",
            value: data[field.dataFieldLabel],
            onChange: e => this._handleChange(field.dataFieldLabel, e.target.value),
            onBlur: e => this._saveInGlobalState(field.dataFieldLabel, e.target.value),
            variant: "outlined",
            disabled: field.disabled
          }));
          break;
        case 'text':
          element = /*#__PURE__*/React.createElement(Grid, {
            item: true,
            xs: field.xs || 6,
            sm: field.sm || 4
          }, /*#__PURE__*/React.createElement(TextInput, {
            label: field.label[language],
            fullWidth: true,
            value: data[field.dataFieldLabel],
            onChange: e => this._handleChange(field.dataFieldLabel, e.target.value),
            onBlur: e => this._saveInGlobalState(field.dataFieldLabel, e.target.value),
            variant: "outlined",
            multiline: field.isMultiline,
            rows: field.isMultiline ? 5 : 1,
            placeholder: field.placeholder ? field.placeholder[language] : null,
            disabled: field.disabled
          }));
          break;
        default:
          return null;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, field.preHeaderLarge && /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Text, {
        mediumLarge: true,
        bold: true,
        margin: "20px 0 -10px 20px"
      }, field.preHeaderLarge[language])), field.preHeader && /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Text, {
        small: true,
        bold: true,
        margin: "10px 0 -20px 20px"
      }, field.preHeader[language])), field.preText && /*#__PURE__*/React.createElement(Grid, {
        container: true
      }, /*#__PURE__*/React.createElement(Text, {
        small: true,
        margin: "10px 0 -10px 20px"
      }, field.preText[language])), element);
    }))));
  }
}
export default ProductBlock;